import { initReactI18next } from 'react-i18next';
import i18next from 'i18next';
import commonEn from './Languages/en_us.json';

i18next.use(initReactI18next).init({
  keySeparator: '.',
  interpolation: { escapeValue: false },
  lng: 'en',
  resources: {
    en: {
      translation: commonEn
    }
  }
});

export default i18next;
